import React, { FC, memo } from 'react';
import { Gender } from 'shared/api/api';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { MoveYoungAnimalButtons } from './move-young-animal-buttons';
import { RegisterYoungAnimalMoveForm } from './register-young-animal-move-form';
import { YoungAnimalMoveEventProvider } from 'shared/helpers/move-young-animal-helper/move-young-animal-provider';

export interface Props {
	closeEditModal?: () => void;
}

export const RegisterMoveYoungAnimalEvent: FC<Props> = memo(props => {
	return (
		<YoungAnimalMoveEventProvider initialState={{ date: new Date(), gender: Gender.Female }}>
			<ViewWeb>
				<MoveYoungAnimalButtons />
				<RegisterYoungAnimalMoveForm />
			</ViewWeb>
		</YoungAnimalMoveEventProvider>
	);
});
